import Base from './Base';
import gsap from 'gsap'
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';
import { evt, utils, store } from '@/core';

const { qs, qsa } = utils;
const { dom, bounds } = store;

import { menuMobile } from '@/components';

export default class extends Base {
  onEnter() {
    super.onEnter();    
    console.log('Entra')
  }

  onLeave() {
    super.onLeave();
  }

  onEnterCompleted() {
    super.onEnterCompleted();  

    const swiperHome = qs(".home-swiper")
    
    swiperHome &&
    new Swiper(swiperHome, {
      spaceBetween:0,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 6500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });


    menuMobile()

    //marquee
    const logos = document.querySelectorAll('.logo-marquee');
    gsap.set(logos, { autoAlpha: 1 })

    logos.forEach((logo, i) => {
      gsap.set(logo, { xPercent: 100 * i });
    });
    if (logos.length > 5) {

      const logosWrap = gsap.utils.wrap(-100, ((logos.length - 1) * 100));
      
      const duration = logos.length * 4.5;

      gsap.to(logos, {
        xPercent: `-=${logos.length * 100}`,
        duration,
        repeat: -1,
        ease: 'none',
        modifiers: {
          xPercent: xPercent => logosWrap(parseFloat(xPercent))
        }
      });

    }
    //marquee Invert
    const logosInvert = document.querySelectorAll('.logo-marquee-invert');
    gsap.set(logosInvert, { autoAlpha: 1 })

    logosInvert.forEach((logo, i) => {
      gsap.set(logo, { xPercent: 100 * i });
    });
    if (logosInvert.length > 5) {
      
      const logosInvertWrap = gsap.utils.wrap(-100, ((logosInvert.length - 1) * 100));
      
      const duration = logosInvert.length * 4.5;

      gsap.to(logosInvert, {
        xPercent: `+=${logosInvert.length * 100}`,
        duration,
        repeat: -1,
        ease: 'none',
        modifiers: {
          xPercent: xPercent => logosInvertWrap(parseFloat(xPercent))
        }
      });

    }

  }

  onLeaveCompleted() {
    super.onLeaveCompleted();
  }

}
